import getWindow from "../../utils/window";
import { getOOSProducts } from "../../utils/product";
import { setEvents, setLinkTrackEvents } from "../events";
import { getCommons, getGlobalEvars } from "../common";
import { getCommonLooksTrackingValues } from "../looks/common";
import { waitForPageLoadAnalytics } from "../pageLoad";

export const fireWaysToStyleModalOpen = async ({ products }) => {
  await waitForPageLoadAnalytics;

  const s = getWindow().s;
  const commons = getCommons();
  s.products = products.map(({ id }) => `;${id};;;;`).join(",");
  setEvents({
    events: [
      `event342=${products.length}`,
      `event343=${getOOSProducts(products).length}`,
    ],
    trackingName: "waysToStyleModalOpen",
  });

  const commonLooksTracking = getCommonLooksTrackingValues({ products });

  s.tl(true, "o", "btl - pop up page", {
    ...commonLooksTracking,
    prop6: "btl cta bottom",
    linkTrackVars: commons.setLinkTrackVars([
      ...getGlobalEvars(),
      ...Object.keys(commonLooksTracking),
      "prop6",
    ]),
    linkTrackEvents: setLinkTrackEvents({
      trackingName: "waysToStyleModalOpen",
    }),
  });
};
